import {useQuery} from 'react-query'
import {GetUrlParameterIds} from '../../services/login-service'

const UseUrlParameterIds = ({instanceName, orgName, fundName, assetName, assetId, actionId}) => {
  const queryParams = ['urlParameterIdsKey', {instanceName, orgName, fundName, assetName, assetId, actionId}]
  const {data} = useQuery(queryParams, GetUrlParameterIds)
  return data ?? {}
}

export default UseUrlParameterIds